import { Link, useSearchParams } from "react-router-dom";
import "./returnToJob.css";

/*
    The way back from a fix link. A job's error links out to the engagement or the
    organization that owns the thing to change; this brings you back to the job you came
    from, with the jobs list still filtered the way you left it.

    The destination is carried in `?from=`, built by the job panel from its own location,
    so it already holds the filters, the page and the selected child.
*/
const JOBS_PREFIX = `${import.meta.env.BASE_URL}jobs/`;

export function returnHref(search: URLSearchParams): string | null {
    // `get` has already percent-decoded this once. Decoding again unescaped the
    // jobs list's own filters -- a search for "R&D" came back as `search=R` plus a
    // stray param, and one containing "%" came back with a dangling escape.
    const from = search.get("from");
    if (!from) return null;
    // Only ever a jobs URL of our own. A `from` is a query parameter like any other and
    // anyone can put one in a link; sending someone to an arbitrary target on the
    // strength of it is how an open redirect starts.
    return from.startsWith(JOBS_PREFIX) ? from : null;
}

export default function ReturnToJob() {
    const [searchParams] = useSearchParams();
    const href = returnHref(searchParams);
    if (!href) return null;

    const jobId = href.slice(JOBS_PREFIX.length).split(/[?#/]/)[0];

    return (
        <Link to={href} className="return-to-job">
            <i className="bi bi-arrow-left" />
            Back to job {jobId ? `#${jobId}` : ""}
        </Link>
    );
}
